import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import {METHOD} from "co-generic-request";
import Urls from "../Urls";
import {FormResultData} from "../../model/FormResult";

export interface FormResultFindCriteria {
    form_id: string,
    exploitation_id: string,
    date: string,
    field_key?: string,
}

/**
 * Busca el resultado de un formulario por explotación y por la fecha guardada en sus
 * valores. Devuelve sólo los values, que es lo único que necesita el botón "Check".
 */
export default class TaskFormResultFind extends BaseGenericRequest<FormResultFindCriteria, TaskResponse<FormResultData>> {

    private readonly data: FormResultFindCriteria;

    public constructor(criteria: FormResultFindCriteria) {
        super(METHOD.METHOD_POST, Urls.URL_FORM_RESULT_FIND);
        this.data = criteria;
    }

    protected getRequest(): FormResultFindCriteria {
        return this.data;
    }

}
